import React from 'react';

// Orijinal HTML'deki 'footer' bölümünün React component'i
function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Aras Asaf İnşaat. Tüm hakları saklıdır.</p>
      
      {/* --- YENİ EKLENDİ --- */}
      <p className="zenginler-credit">
        Bu web sitesi <a href="https://www.pczero.com.tr" target="_blank" rel="noopener noreferrer">Zenginler Yazılım</a> tarafından yapılmıştır.
      </p>
    </footer>
  );
}

export default Footer;